const initSelect2 = async function () {
    var isSelectLoaded = false;

    // $(".btn-form-register").each(function (index) {
    //     $(this).on("click", function () {
    //         loadSelect();
    //     });
    // });

    const loadSelect = async () => {
        if (!isSelectLoaded) {
            let select2 = await (await import('select2')).default;
            isSelectLoaded = true;
            $(".form-register__row").each((i, element) => {
                // const label = $(element).data("label");
                const label = "Please select";

                if (label) {
                    $(element).find(".wpcf7-select").select2({
                        placeholder: label,
                        allowClear: false,
                        width: 'element'
                    });
                } else {
                    $(element).find(".wpcf7-select").select2();
                }
            });
            
            $(".wpcf7-select").addClass("hidden");
        }
    }
};

export const init = initSelect2;